/* Optic Souq — design layer behaviour (order pad, search, drawer, quick add).
   Deliberately does NOT touch the product page or cart page: those keep the
   theme's own existing scripts. Figures shown here are display only.

   EVENT BINDING: this theme re-renders sections after load (morph.js /
   section-hydration.js), which discards listeners attached directly to
   elements. Everything here is delegated from document so it survives.
   Do not convert these back to per-element addEventListener.

   The "View models" toggle on Shop by Series deliberately lives in
   snippets/os2-models-toggle.liquid, not here — see that file for why. */
(function () {
  'use strict';

  var CFG = window.OS2 || {};
  var MOQ = CFG.moq || 3;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* money — uses the shop's own money_format so JS matches Liquid's | money */
  function group(v, decimals) {
    var s = Math.abs(v).toFixed(decimals);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (v < 0 ? '-' : '') + parts.join(decimals ? '.' : '');
  }
  function money(paise) {
    var n = Math.round(paise) / 100;
    var fmt = CFG.moneyFormat || '₹{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      if (key.indexOf('no_decimals') > -1) return group(n, 0);
      return group(n, 2);
    });
  }
  window.os2Money = money;

  /* toast */
  var toastEl, toastT;
  function toast(msg, href, label) {
    if (toastEl) toastEl.remove();
    toastEl = document.createElement('div');
    toastEl.className = 'os2-toast';
    toastEl.setAttribute('role', 'status');
    var i = document.createElement('i');
    var s = document.createElement('span');
    s.textContent = msg;
    toastEl.appendChild(i); toastEl.appendChild(s);
    if (href) { var a = document.createElement('a'); a.href = href; a.textContent = label || 'View order'; toastEl.appendChild(a); }
    document.body.appendChild(toastEl);
    clearTimeout(toastT);
    toastT = setTimeout(function () { if (toastEl) { toastEl.remove(); toastEl = null; } }, 2600);
  }
  window.os2Toast = toast;

  function gated() {
    toast(CFG.loggedIn ? 'Your dealer account is awaiting approval' : 'Login to order', CFG.loginUrl, 'Log in');
  }

  /* overlays */
  function openOv(el) {
    if (!el) return;
    el.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('input,button,a');
    if (f) setTimeout(function () { f.focus(); }, 30);
  }
  function closeAll() {
    $$('.os2-ov.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    var d = $('#os2-drawer'); if (d) d.hidden = true;
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-os2-open]');
    if (o) { e.preventDefault(); openOv($('#' + o.getAttribute('data-os2-open'))); return; }
    if (e.target.closest('[data-os2-close]')) { e.preventDefault(); closeAll(); return; }
    if (e.target.classList && e.target.classList.contains('os2-ov')) closeAll();
    if (e.target.closest('[data-os2-drawer]')) {
      e.preventDefault();
      var d = $('#os2-drawer');
      if (d) { d.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); openOv($('#os2-search')); }
  });

  /* search — predictive results while typing, full results page on Enter.
     The input also sits in a real <form>, so Enter still works without JS. */
  var searchT;
  function searchUrl(q) {
    var base = (CFG.routes && CFG.routes.search) || '/search';
    return base + '?q=' + encodeURIComponent(q) + '&type=product';
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest ? e.target.closest('[data-os2-q]') : null;
    if (!input) return;
    var q = (input.value || '').trim();
    if (!q) { e.preventDefault(); return; }
    e.preventDefault();
    window.location.assign(searchUrl(q));
  });
  document.addEventListener('input', function (e) {
    var input = e.target.closest ? e.target.closest('[data-os2-q]') : null;
    if (!input) return;
    var srchOut = $('[data-os2-results]');
    var srchEmpty = $('[data-os2-sempty]');
    if (!srchOut) return;
    clearTimeout(searchT);
    var q = input.value.trim();
    if (!q) { srchOut.innerHTML = ''; if (srchEmpty) srchEmpty.hidden = false; return; }
    if (srchEmpty) srchEmpty.hidden = true;
    searchT = setTimeout(function () {
      fetch(CFG.routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=os2-predictive')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var list = doc.querySelector('[data-os2-plist]');
          srchOut.innerHTML = list ? list.innerHTML : '';
        }).catch(function () { srchOut.innerHTML = ''; });
    }, 220);
  });

  /* cart api */
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j); }); });
  }
  function addItems(items, msg) {
    if (!items.length) return;
    post(CFG.routes.cartAdd, { items: items })
      .then(function () { return fetch(CFG.routes.cart + '.js').then(function (r) { return r.json(); }); })
      .then(function (c) {
        $$('[data-os2-count]').forEach(function (el) { el.textContent = c.item_count > 99 ? '99+' : c.item_count; });
        toast(msg, CFG.routes.cart, 'View order');
      })
      .catch(function (err) { toast((err && err.description) || 'Could not add to order'); });
  }
  window.os2Add = addItems;

  /* steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-plus],[data-minus]');
    if (!b) return;
    var box = b.closest('.os2-step');
    if (!box) return;
    if (box.hasAttribute('data-gated')) { e.preventDefault(); gated(); return; }
    var out = box.querySelector('output');
    if (!out) return;
    var v = parseInt(out.value || out.textContent, 10) || 0;
    v = b.hasAttribute('data-plus') ? v + 1 : Math.max(0, v - 1);
    out.value = v; out.textContent = v;
    box.dispatchEvent(new CustomEvent('os2:qty', { bubbles: true, detail: { qty: v } }));
  });

  /* order pad rows — recomputed from the DOM, so a re-render is harmless */
  function renderRow(row) {
    var exemptRow = row.getAttribute('data-exempt') === 'true';
    var line = $('[data-os2-line]', row);
    var stat = $('[data-os2-stat]', row);
    var pcs = 0, val = 0;
    /* GST display (2026-10-16): rows marked data-os-sg (Charge tax on) show the total + GST.
       window.OSSG exists only when os_sg_gst_mode is on (snippets/os-sg-gst-price.liquid). */
    var sg = row.hasAttribute('data-os-sg') ? window.OSSG : null;
    $$('.os2-step', row).forEach(function (s) {
      var out = $('output', s);
      if (!out) return;
      var q = parseInt(out.value, 10) || 0;
      var p = parseInt(s.getAttribute('data-price'), 10) || 0;
      pcs += q * (parseInt(s.getAttribute('data-units'), 10) || 1);
      val += q * (sg ? sg.split(p).base : p);
    });
    if (line) line.textContent = pcs ? (sg ? sg.fmt(val) + ' + GST' : money(val)) : '';
    if (stat) {
      if (!pcs) { stat.textContent = ''; stat.className = ''; }
      else if (exemptRow || pcs >= MOQ) { stat.textContent = pcs + ' pcs ✓'; stat.className = ''; }
      else { stat.textContent = 'need ' + (MOQ - pcs) + ' more'; stat.className = 'is-short'; }
    }
  }
  document.addEventListener('os2:qty', function (e) {
    var row = e.target.closest ? e.target.closest('[data-os2-padrow]') : null;
    if (row) renderRow(row);
  });
  function renderAllRows() { $$('[data-os2-padrow]').forEach(renderRow); }
  renderAllRows();

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-os2-padadd]')) return;
    if (CFG.gated) { gated(); return; }
    var items = [], short = 0, rows = 0;
    $$('[data-os2-padrow]').forEach(function (row) {
      var pcs = 0, rowItems = [];
      $$('.os2-step', row).forEach(function (s) {
        var out = $('output', s);
        if (!out) return;
        var q = parseInt(out.value, 10) || 0;
        if (q > 0) {
          rowItems.push({ id: parseInt(s.getAttribute('data-vid'), 10), quantity: q });
          pcs += q * (parseInt(s.getAttribute('data-units'), 10) || 1);
        }
      });
      if (!pcs) return;
      rows++;
      if (row.getAttribute('data-exempt') !== 'true' && pcs < MOQ) { short++; return; }
      items = items.concat(rowItems);
    });
    if (!rows) { toast('Add quantities first'); return; }
    if (short) { toast(short + ' product' + (short === 1 ? '' : 's') + ' below the ' + MOQ + '-piece minimum'); return; }
    addItems(items, 'Order pad added · ' + items.length + ' line' + (items.length === 1 ? '' : 's'));
    $$('[data-os2-padrow] output').forEach(function (o) { o.value = 0; o.textContent = '0'; });
    renderAllRows();
  });

  /* quick add from cards */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-os2-quick]');
    if (!b) return;
    e.preventDefault();
    if (CFG.gated) { gated(); return; }
    addItems([{ id: parseInt(b.getAttribute('data-vid'), 10), quantity: parseInt(b.getAttribute('data-qty'), 10) || MOQ }],
      b.getAttribute('data-msg') || 'Added to order');
  });

  /* how to order steps */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-os2-step]');
    if (!a) return;
    e.preventDefault();
    var n = a.getAttribute('data-os2-step');
    $$('.os2-steps [data-os2-step]').forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-os2-step') === n); });
    $$('[data-os2-steppanel]').forEach(function (p) { p.hidden = p.getAttribute('data-os2-steppanel') !== n; });
  });

  /* contact confirmation */
  var cf = $('[data-os2-contact]');
  if (cf && /contact_posted=true/.test(window.location.search)) {
    var done = $('[data-os2-contactdone]');
    if (done) { cf.hidden = true; done.hidden = false; }
  }
})();
